const translations = {
  title: "Catalog",
  subtitle: "Designs, references and saved patterns for orders and stock.",
  add_design: "Add Design",
  search_placeholder: "Search by code, name, tag…",
  all_categories: "All categories",
  tab_all: "All Designs",
  tab_internal: "Internal",
  tab_customer_reference: "Customer Reference",
  tab_external: "External",
  tab_saved_from_order: "Saved From Orders",
  no_designs: "No designs yet.",
  click_add_design: "to create one.",
  under_construction_title: "Photo / file upload",
  under_construction_desc:
    "File upload storage will be enabled in a future version. For the pilot, attach physical files to the corresponding paper register and note the design number.",
  understood: "Understood",
  export_csv: "Export CSV",
  export_success: "Catalog exported successfully.",
  total_designs: "Total designs",
  internal_designs: "Internal",
  customer_refs: "Customer references",
  saved_orders: "Saved from orders",
  design_number: "Design number",
  design_name: "Design name",
  design_name_placeholder: "e.g. Filigree Ring",
  category: "Category",
  custom: "Custom",
  custom_category_placeholder: "Enter custom category",
  subcategory: "Subcategory",
  subcategory_placeholder: "e.g. Antique",
  item_type: "Item type",
  item_type_placeholder: "Ladies / Gents / Kid",
  purity: "Purity / touch",
  approx_gross: "Approx gross",
  approx_net: "Approx net",
  making_difficulty: "Making difficulty",
  source: "Source",
  source_internal: "Internal",
  source_customer_reference: "Customer reference",
  source_external: "External / supplier",
  source_saved_from_order: "Saved from order",
  difficulty_easy: "Easy",
  difficulty_medium: "Medium",
  difficulty_hard: "Hard",
  customer: "Customer",
  no_customer: "No linked customer",
  tags: "Tags (comma separated)",
  tags_placeholder: "filigree, antique, bridal",
  notes: "Notes",
  add_design_desc: "Create a reusable design entry with its references and production details.",
  design_name_required: "Design name is required.",
  category_required: "Category is required.",
  duplicate_design: "Design number {number} already exists. Use a unique number.",
  invalid_weight: "Weights must be positive and net weight cannot exceed gross weight.",
  design_saved: "Design {number} saved.",
  save_design: "Save design",
  cancel: "Cancel",
  design_photo: "Design photo",
  add_design_photo: "Add design photo",
  customer_reference_attachment: "Customer reference",
  attach_customer_reference: "Attach customer reference",
  technical_drawing: "Technical drawing",
  attach_technical_drawing: "Attach technical drawing",
  not_found: "Design not found.",
  back: "Back",
  edit: "Edit",
  save_changes: "Save changes",
  changes_saved: "Design changes saved.",
  upload_photo: "Upload design photo for",
  no_photo_desc: "No design photo on file. Upload a JPG or PNG image to display it here.",
  from_order: "From order",
  delete: "Delete",
  delete_title: "Delete this design?",
  delete_description: "This removes the catalog entry. This action cannot be undone.",
  design_deleted: "Design deleted.",
};

export default translations;
